import React, { useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import CheckImg from "../images/check.svg";
function RoomDataModal(props) {
  function closeModal() {
    props.hide();
  }

  useEffect(() => {
    console.log(props);
  }, [props]);
  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-[#171538] p-4 pt-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  <div className="room-modal flex-col items-center justify-center mt-2">
                    <div className="flex justify-center items-center"></div>
                    {props.roomData.img && (
                      //   <img
                      //     className="top-0 left-0 absolute h-[200px]"
                      //     src={props.roomData.img}
                      //     alt=""
                      //   />
                      <div
                        className="absolute top-0 left-0 w-full h-[200px]"
                        style={{
                          background: `url(${props.roomData.img})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      ></div>
                    )}
                  </div>
                  <div className="pt-[190px] room-modal">
                    <div className="head mt-2">{props.roomData.name}</div>
                    <div className="sub-head mt-1 mb-2">Description</div>
                    <p>{props.roomData.description}</p>
                    {props.roomData.fecilities.length !== 0 && (
                      <div>
                        <div className="sub-head mt-4">Room facilities</div>
                        <div className="grid grid-flow-row grid-cols-2 gap-2 mt-3">
                          {props.roomData.fecilities.map((item, i) => (
                            <div key={i} className="flex items-center gap-2">
                              <img className="w-3 h-3" src={CheckImg} alt="" />
                              <div className="type-name">{item}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="absolute top-2 right-2 bg-gray-500 rounded pt-1 px-2">
                    <button
                      type="button"
                      className="outline-none rounded-full hover:bg-gray-100"
                      onClick={closeModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
   );
}

export default RoomDataModal;
